import React from "react";

import * as typography from "@client/shared/typography";

import {Layout} from "@client/site/Layout";

export const Template = () => (
    <Layout narrow title="Privacy Policy">
        <typography.Header>Privacy Policy</typography.Header>
        <typography.P>At Joy we have a few fundamental principles:</typography.P>
        <ul>
            <li>
                We don&rsquo;t ask you for personal information unless we truly need it.
                (We can&rsquo;t stand services that ask you for things like your gender
                or income level for no apparent reason.)
            </li>
            <li>
                We don&rsquo;t share your personal information with anyone except to
                comply with the law, develop our products, or protect our rights.
            </li>
            <li>
                We don&rsquo;t store personal information on our servers unless required
                for the on-going operation of one of our services.
            </li>
            <li>
                In our products, we aim to make it as simple as possible for you to
                control what&rsquo;s visible to the public, seen by search engines, kept
                private, and permanently deleted.
            </li>
            <li>
                If you have questions about deleting or correcting your personal data
                please contact our support team.
            </li>
        </ul>
        <typography.P>
            Joy Network, LLC (&ldquo;Joy&rdquo;) operates several websites including
            joyapp.com. It is Joy&rsquo;s policy to respect your privacy regarding any
            information we may collect while operating our websites.
        </typography.P>

        <h3>Website Visitors</h3>
        <typography.P>
            Like most website operators, Joy collects non-personally-identifying
            information of the sort that web browsers and servers typically make
            available, such as the browser type, language preference, referring site,
            and the date and time of each visitor request. Joy&rsquo;s purpose in
            collecting non-personally identifying information is to better understand
            how Joy&rsquo;s visitors use its website. From time to time, Joy may release
            non-personally-identifying information in the aggregate, e.g., by publishing
            a report on trends in the usage of its website.
        </typography.P>
        <typography.P>
            Joy also collects potentially personally-identifying information like
            Internet Protocol (IP) addresses for logged in users. Joy only discloses
            logged in user addresses under the same circumstances that it uses and
            discloses personally-identifying information as described below.
        </typography.P>

        <h3>Analytics</h3>
        <typography.P>
            Joy relies on two analytics services. We never share this data with other
            sites or across the internet.
        </typography.P>
        <ul>
            <li>
                Mixpanel: used to keep track of actions and events on our app. This
                helps us measure feature popularity, sign ups, etc.
            </li>
            <li>
                Google Analytics: used to measure page views on our marketing and
                information pages. The analytics help us determine where traffic is
                coming from, including referrals, search, etc. We do not currently use
                Google Analytics in the application itself. Solely on the website.
            </li>
        </ul>
        <typography.P>
            There are no other tracking mechanisms on the site, including third-party
            cookies of any kind.
        </typography.P>

        <h3>Gathering of Personally-Identifying Information</h3>
        <typography.P>
            Certain visitors to Joy&rsquo;s websites choose to interact with Joy in ways
            that require Joy to gather personally-identifying information. The amount
            and type of information that Joy gathers depends on the nature of the
            interaction. For example, we ask visitors who sign up for a site at
            joyapp.com to provide a username and email address. Those who engage in
            transactions with Joy &ndash; by purchasing a plan, for example &ndash; are
            asked to provide additional information, including as necessary the personal
            and financial information required to process those transactions. In each
            case, Joy collects such information only insofar as is necessary or
            appropriate to fulfill the purpose of the visitor&rsquo;s interaction with
            Joy. Joy does not disclose personally-identifying information other than as
            described below. And visitors can always refuse to supply
            personally-identifying information, with the caveat that it may prevent them
            from engaging in certain website-related activities.
        </typography.P>

        <h3>Aggregated Statistics</h3>
        <typography.P>
            Joy may collect statistics about the behavior of visitors to its websites.
            For instance, Joy may monitor the most popular sites. Joy may display this
            information publicly or provide it to others. However, Joy does not disclose
            personally-identifying information other than as described below.
        </typography.P>

        <h3>Protection of Certain Personally-Identifying Information</h3>
        <typography.P>
            Joy discloses potentially personally-identifying and personally-identifying
            information only to those of its employees, contractors and affiliated
            organizations that (i) need to know that information in order to process it
            on Joy&rsquo;s behalf or to provide services available at Joy&rsquo;s
            websites, and (ii) that have agreed not to disclose it to others. Some of
            those employees, contractors and affiliated organizations may be located
            outside of your home country; by using Joy&rsquo;s websites, you consent to
            the transfer of such information to them. Joy will not rent or sell
            potentially personally-identifying and personally-identifying information to
            anyone. Other than to its employees, contractors and affiliated
            organizations, as described above, Joy discloses potentially
            personally-identifying and personally-identifying information only in
            response to a subpoena, court order or other governmental request, or when
            Joy believes in good faith that disclosure is reasonably necessary to
            protect the property or rights of Joy, third parties or the public at large.
            If you are a registered user of an Joy website and have supplied your email
            address, Joy may occasionally send you an email to tell you about new
            features, solicit your feedback, or just keep you up to date with
            what&rsquo;s going on with Joy and our products. We primarily use our
            various product blogs to communicate this type of information, so we expect
            to keep this type of email to a minimum. If you send us a request (for
            example via a support email or via one of our feedback mechanisms), we
            reserve the right to publish it in order to help us clarify or respond to
            your request or to help us support other users. Joy takes all measures
            reasonably necessary to protect against the unauthorized access, use,
            alteration or destruction of potentially personally-identifying and
            personally-identifying information.
        </typography.P>

        <h3>Cookies</h3>
        <typography.P>
            A cookie is a string of information that a website stores on a
            visitor&rsquo;s computer, and that the visitor&rsquo;s browser provides to
            the website each time the visitor returns. Joy uses cookies to help Joy
            identify and track visitors, their usage of Joy website, and their website
            access preferences. Joy visitors who do not wish to have cookies placed on
            their computers should set their browsers to refuse cookies before using
            Joy&rsquo;s websites, with the drawback that certain features of Joy&rsquo;s
            websites may not function properly without the aid of cookies.
        </typography.P>

        <h3>Business Transfers</h3>
        <typography.P>
            If Joy, or substantially all of its assets, were acquired, or in the
            unlikely event that Joy goes out of business or enters bankruptcy, user
            information would be one of the assets that is transferred or acquired by a
            third party. You acknowledge that such transfers may occur, and that any
            acquirer of Joy may continue to use your personal information as set forth
            in this policy.
        </typography.P>

        <h3>Ads</h3>
        <typography.P>
            JoyApp does not sell any advertising space in our app or on our website. Our
            business relies 100% on user subscriptions instead of making money selling
            your personal data to third-parties or advertisers. We&rsquo;ve chosen to do
            business this way because we believe the information you enter into our app
            and website is incredibly personal and should not be used for profit.
        </typography.P>
        <typography.P>
            Furthermore, we take additional measures to protect the sensitive
            information that you entrust to us. We use end-to-end encryption on all
            communications between our app, website, and servers. This means malicious
            parties cannot capture your information as it is being transmitted to us.
            Any sensitive information that we do store is strictly for internal
            analysis.
        </typography.P>
        <typography.P>
            We <em>never</em> store your credit card or any other financial information.
        </typography.P>

        <h3>Privacy Policy Changes</h3>
        <typography.P>
            Although most changes are likely to be minor, Joy may change its Privacy
            Policy from time to time, and in Joy&rsquo;s sole discretion. Joy encourages
            visitors to frequently check this page for any changes to its Privacy
            Policy. If you have a joyapp.com account, you should also check your
            site&rsquo;s dashboard for alerts to these changes. Your continued use of
            this site after any change in this Privacy Policy will constitute your
            acceptance of such change.
        </typography.P>
    </Layout>
);
